module.exports = __webpack_public_path__ + "img/defaultImage.a47b8f5.png";